import { GIFTIE_CONTENT_FONT_VARIABLE } from '@giftie/yuzu-integration'

export type ResolvedThemeFonts = {
  contentFamily: string
  contentSrc: string
  contentWeight: string
  contentFormat: string
  builderUiFamily: string
  builderUiSrc: string
  builderUiWeight: string
  builderUiFormat: string
}

function readQueryValue(value: unknown): string {
  const rawValue = Array.isArray(value) ? value[0] : value
  if (typeof rawValue !== 'string' || !rawValue) return ''
  try {
    return decodeURIComponent(rawValue)
  } catch {
    return ''
  }
}

function inferFontFormat(src: string): string {
  const extension = src.split('?')[0]?.split('.').pop()?.toLowerCase()
  if (extension === 'woff2') return 'woff2'
  if (extension === 'woff') return 'woff'
  if (extension === 'ttf') return 'truetype'
  if (extension === 'otf') return 'opentype'
  return ''
}

export function resolveThemeFonts(query: Record<string, unknown>): ResolvedThemeFonts {
  const contentFamily = readQueryValue(query.brandFontFamily || query.fontFamily)
  const contentSrc = readQueryValue(query.brandFontSrc || query.fontSrc)
  const contentWeight = readQueryValue(query.brandFontWeight || query.fontWeight) || '400'
  const contentFormat = readQueryValue(query.brandFontFormat) || inferFontFormat(contentSrc)
  const builderUiFamily = readQueryValue(
    query.builderFontFamily || query.fontFamily || query.brandFontFamily,
  )
  const builderUiSrc = readQueryValue(
    query.builderFontSrc || query.fontSrc || query.brandFontSrc,
  )
  const builderUiWeight = readQueryValue(
    query.builderFontWeight || query.fontWeight || query.brandFontWeight,
  ) || '400'
  const builderUiFormat = readQueryValue(
    query.builderFontFormat || query.fontFormat,
  ) || inferFontFormat(builderUiSrc)

  return {
    contentFamily,
    contentSrc,
    contentWeight,
    contentFormat,
    builderUiFamily,
    builderUiSrc,
    builderUiWeight,
    builderUiFormat,
  }
}

/** Exposes the Shopify-projected Content font to Yuzu-authored Giftie schemas. */
export function createGiftieContentFontVariables(contentFamily: string) {
  return contentFamily
    ? { [GIFTIE_CONTENT_FONT_VARIABLE]: contentFamily }
    : {}
}
